const TABS_LABELS = {
  PENDING: 0,
  PAST: 1,
};

const REQUEST_TYPES = Object.freeze({
  DEVICE: 'device',
  ADDON: 'addon',
  LICENCE: 'licence',
});

const REQUEST_ACTIONS = Object.freeze({
  APPROVE: 'approve',
  REJECT: 'reject',
  APPROVE_MULTI: 'approve_multi',
  REJECT_MULTI: 'reject_multi',
  CANCEL: 'cancel',
});

const REQUESTS_LOADING_CONFIG = Object.freeze({
  [REQUEST_TYPES.DEVICE || REQUEST_TYPES.ADDON || REQUEST_TYPES.LICENCE]: {
    subTitle: 'soho_requests_modal_loading_screen_subtitle',
  },
});

const REQUESTS_QUICK_ACTION_MENU_CONFIG = Object.freeze({
  [REQUEST_TYPES.DEVICE]: {
    [REQUEST_ACTIONS.APPROVE]: {
      title: 'soho_requests_approve_device_quick_action_title',
      description: 'soho_requests_approve_device_quick_action_description',
      confirmButtonTitle: 'soho_requests_approve_device_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_approve_device_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.REJECT]: {
      title: 'soho_requests_reject_device_quick_action_title',
      description: 'soho_requests_reject_device_quick_action_description',
      confirmButtonTitle: 'soho_requests_reject_device_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_reject_device_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.CANCEL]: {
      title: 'soho_requests_cancel_device_quick_action_title',
      description: 'soho_requests_cancel_device_quick_action_description',
      confirmButtonTitle: 'soho_requests_cancel_device_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_cancel_device_quick_action_cancel_button_title',
    },
  },
  [REQUEST_TYPES.ADDON]: {
    [REQUEST_ACTIONS.APPROVE]: {
      title: 'soho_requests_approve_addon_quick_action_title',
      description: 'soho_requests_approve_addon_quick_action_description',
      confirmButtonTitle: 'soho_requests_approve_addon_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_approve_addon_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.REJECT]: {
      title: 'soho_requests_reject_addon_quick_action_title',
      description: 'soho_requests_reject_addon_quick_action_description',
      confirmButtonTitle: 'soho_requests_reject_addon_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_reject_addon_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.CANCEL]: {
      title: 'soho_requests_cancel_addon_quick_action_title',
      description: 'soho_requests_cancel_addon_quick_action_description',
      confirmButtonTitle: 'soho_requests_cancel_addon_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_cancel_addon_quick_action_cancel_button_title',
    },
  },
  [REQUEST_TYPES.LICENCE]: {
    [REQUEST_ACTIONS.APPROVE]: {
      title: 'soho_requests_approve_licence_quick_action_title',
      description: 'soho_requests_approve_licence_quick_action_description',
      confirmButtonTitle: 'soho_requests_approve_licence_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_approve_licence_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.REJECT]: {
      title: 'soho_requests_reject_licence_quick_action_title',
      description: 'soho_requests_reject_licence_quick_action_description',
      confirmButtonTitle: 'soho_requests_reject_licence_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_reject_licence_quick_action_cancel_button_title',
    },
    [REQUEST_ACTIONS.CANCEL]: {
      title: 'soho_requests_cancel_licence_quick_action_title',
      description: 'soho_requests_cancel_licence_quick_action_description',
      confirmButtonTitle: 'soho_requests_cancel_licence_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_requests_cancel_licence_quick_action_cancel_button_title',
    },
  },
});

const MULTIPLE_REQUESTS_QUICK_ACTION_MENU_CONFIG = Object.freeze({
  [REQUEST_TYPES.DEVICE]: {
    [REQUEST_ACTIONS.APPROVE_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.DEVICE][REQUEST_ACTIONS.APPROVE],
      description: 'soho_multiple_requests_approve_device_quick_action_description',
    },
    [REQUEST_ACTIONS.REJECT_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.DEVICE][REQUEST_ACTIONS.REJECT],
      description: 'soho_multiple_requests_reject_device_quick_action_description',
    },
  },
  [REQUEST_TYPES.ADDON]: {
    [REQUEST_ACTIONS.APPROVE_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.ADDON][REQUEST_ACTIONS.APPROVE],
      description: 'soho_multiple_requests_approve_addon_quick_action_description',
    },
    [REQUEST_ACTIONS.REJECT_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.ADDON][REQUEST_ACTIONS.REJECT],
      description: 'soho_multiple_requests_reject_addon_quick_action_description',
    },
  },
  [REQUEST_TYPES.LICENCE]: {
    [REQUEST_ACTIONS.APPROVE_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.LICENCE][REQUEST_ACTIONS.APPROVE],
      description: 'soho_multiple_requests_approve_licence_quick_action_description',
    },
    [REQUEST_ACTIONS.REJECT_MULTI]: {
      ...REQUESTS_QUICK_ACTION_MENU_CONFIG[REQUEST_TYPES.LICENCE][REQUEST_ACTIONS.REJECT],
      description: 'soho_multiple_requests_reject_licence_quick_action_description',
    },
  },
});

const REQUESTS_SUCCESS_SCREEN_CONFIG = Object.freeze({
  [REQUEST_TYPES.DEVICE]: {
    [REQUEST_ACTIONS.APPROVE]: {
      title: 'soho_requests_approve_device_success_modal_title',
      description: 'soho_requests_approve_device_success_modal_description',
      subtitle: 'soho_requests_approve_device_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_approve_device_success_modal_primary_button_title',
    },
    [REQUEST_ACTIONS.REJECT]: {
      title: 'soho_requests_reject_device_success_modal_title',
      description: 'soho_requests_reject_device_success_modal_description',
      subtitle: 'soho_requests_reject_device_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_reject_device_success_modal_primary_button_title',
    },
    [REQUEST_ACTIONS.APPROVE_MULTI]: isAllUsersSelected => ({
      title: 'soho_requests_approve_device_success_modal_title',
      description: 'soho_multiple_requests_approve_device_success_modal_description',
      subtitle: 'soho_multiple_requests_approve_device_success_modal_subtitle',
      extraContent: 'soho_multiple_requests_approve_devices_success_modal_extra_text',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
          }
        : {
            secondaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
            primaryBtnTitle: 'soho_multiple_requests_approve_device_primary_button_title',
            withSecondaryButton: true,
          }),
    }),
    [REQUEST_ACTIONS.REJECT_MULTI]: isAllUsersSelected => ({
      title: 'soho_requests_reject_device_success_modal_title',
      description: 'soho_multiple_requests_reject_device_success_modal_description',
      subtitle: 'soho_multiple_requests_reject_device_success_modal_subtitle',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_requests_reject_device_success_modal_primary_button_title',
          }
        : {
            withSecondaryButton: true,
            primaryBtnTitle: 'soho_multiple_requests_reject_device_primary_button_title',
            secondaryBtnTitle: 'soho_requests_reject_device_success_modal_primary_button_title',
          }),
    }),
    [REQUEST_ACTIONS.CANCEL]: {
      title: 'soho_requests_cancel_device_success_modal_title',
      description: 'soho_requests_cancel_device_success_modal_description',
      subtitle: 'soho_requests_cancel_device_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_cancel_device_success_modal_primary_button_title',
    },
  },
  [REQUEST_TYPES.ADDON]: {
    [REQUEST_ACTIONS.APPROVE]: {
      title: 'soho_requests_approve_addon_success_modal_title',
      description: 'soho_requests_approve_addon_success_modal_description',
      subtitle: 'soho_requests_approve_addon_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_approve_addon_success_modal_primary_button_title',
    },
    [REQUEST_ACTIONS.REJECT]: {
      title: 'soho_requests_reject_addon_success_modal_title',
      description: 'soho_requests_reject_addon_success_modal_description',
      subtitle: 'soho_requests_reject_addon_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_reject_addon_success_modal_primary_button_title',
    },
    [REQUEST_ACTIONS.APPROVE_MULTI]: isAllUsersSelected => ({
      title: 'soho_requests_approve_addon_success_modal_title',
      description: 'soho_multiple_requests_approve_addon_success_modal_description',
      subtitle: 'soho_multiple_requests_approve_addon_success_modal_subtitle',
      extraText: 'soho_multiple_requests_approve_addon_success_modal_extra_text',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
          }
        : {
            secondaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
            withSecondaryButton: true,
            primaryBtnTitle: 'soho_multiple_requests_approve_addon_primary_button_title',
          }),
    }),
    [REQUEST_ACTIONS.REJECT_MULTI]: isAllUsersSelected => ({
      title: 'soho_requests_reject_addon_success_modal_title',
      description: 'soho_multiple_requests_reject_addon_success_modal_description',
      subtitle: 'soho_multiple_requests_reject_addon_success_modal_subtitle',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_requests_reject_addon_success_modal_primary_button_title',
          }
        : {
            primaryBtnTitle: 'soho_multiple_requests_reject_addon_primary_button_title',
            withSecondaryButton: true,
            secondaryBtnTitle: 'soho_requests_reject_addon_success_modal_primary_button_title',
          }),
    }),
    [REQUEST_ACTIONS.CANCEL]: {
      title: 'soho_requests_cancel_addon_success_modal_title',
      description: 'soho_requests_cancel_addon_success_modal_description',
      subtitle: 'soho_requests_cancel_addon_success_modal_subtitle',
      primaryBtnTitle: 'soho_requests_cancel_addon_success_modal_primary_button_title',
    },
  },
  [REQUEST_TYPES.LICENCE]: {
    [REQUEST_ACTIONS.APPROVE]: {
      description: 'soho_requests_approve_licence_success_modal_description',
      title: 'soho_requests_approve_licence_success_modal_title',
      primaryBtnTitle: 'soho_requests_approve_licence_success_modal_primary_button_title',
      subtitle: 'soho_requests_approve_licence_success_modal_subtitle',
    },
    [REQUEST_ACTIONS.REJECT]: {
      description: 'soho_requests_reject_licence_success_modal_description',
      title: 'soho_requests_reject_licence_success_modal_title',
      primaryBtnTitle: 'soho_requests_reject_licence_success_modal_primary_button_title',
      subtitle: 'soho_requests_reject_licence_success_modal_subtitle',
    },
    [REQUEST_ACTIONS.APPROVE_MULTI]: isAllUsersSelected => ({
      description: 'soho_multiple_requests_approve_licence_success_modal_description',
      title: 'soho_requests_approve_licence_success_modal_title',
      extraText: 'soho_multiple_requests_approve_license_success_modal_extra_text',
      subtitle: 'soho_multiple_requests_approve_licence_success_modal_subtitle',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
          }
        : {
            withSecondaryButton: true,
            primaryBtnTitle: 'soho_multiple_requests_approve_licence_primary_button_title',
            secondaryBtnTitle: 'soho_multiple_requests_approve_secondary_button_title',
          }),
    }),
    [REQUEST_ACTIONS.REJECT_MULTI]: isAllUsersSelected => ({
      description: 'soho_multiple_requests_reject_licence_success_modal_description',
      title: 'soho_requests_reject_licence_success_modal_title',
      ...(isAllUsersSelected
        ? {
            primaryBtnTitle: 'soho_requests_reject_licence_success_modal_primary_button_title',
          }
        : {
            secondaryBtnTitle: 'soho_requests_reject_licence_success_modal_primary_button_title',
            primaryBtnTitle: 'soho_multiple_requests_reject_licence_primary_button_title',
            withSecondaryButton: true,
          }),
      subtitle: 'soho_multiple_requests_reject_licence_success_modal_subtitle',
    }),
    [REQUEST_ACTIONS.CANCEL]: {
      description: 'soho_requests_cancel_licence_success_modal_description',
      title: 'soho_requests_cancel_licence_success_modal_title',
      primaryBtnTitle: 'soho_requests_cancel_licence_success_modal_primary_button_title',
      subtitle: 'soho_requests_cancel_licence_success_modal_subtitle',
    },
  },
});

const REQUESTS_FAILURE_SCREEN_CONFIG = {
  title: 'soho_requests_failure_modal_title',
  primaryBtnTitle: 'soho_requests_failure_modal_try_again_button_title',
  secondaryBtnTitle: 'soho_requests_failure_modal_cancel_button_title',
};

const REQUEST_STATUS = {
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};

const TABS = [
  {
    key: TABS_LABELS.PENDING,
    tab_key: 'soho_requests_pending_tab_title',
  },
  {
    key: TABS_LABELS.PAST,
    tab_key: 'soho_requests_past_tab_title',
  },
];

export {
  TABS_LABELS,
  TABS,
  REQUEST_TYPES,
  REQUEST_STATUS,
  REQUESTS_QUICK_ACTION_MENU_CONFIG,
  MULTIPLE_REQUESTS_QUICK_ACTION_MENU_CONFIG,
  REQUESTS_LOADING_CONFIG,
  REQUESTS_SUCCESS_SCREEN_CONFIG,
  REQUEST_ACTIONS,
  REQUESTS_FAILURE_SCREEN_CONFIG,
};
